import { Mui } from "@osu/react-ui";

function SessionAlert({ isDraft, sx = { my: 2 }, ...rest }) {
  if (isDraft) {
    return (
      <Mui.Alert severity="warning" sx={sx} {...rest}>
        <Mui.AlertTitle color="inherit">Period Not Created</Mui.AlertTitle>
        This session has not been created yet. Please create this session and
        specify your submissions window.
      </Mui.Alert>
    );
  }
  return false;
}

export default SessionAlert;
